export var AmmoType;
(function (AmmoType) {
    AmmoType[AmmoType["Unlimited"] = 0] = "Unlimited";
    AmmoType[AmmoType["Kinetic"] = 1] = "Kinetic";
    AmmoType[AmmoType["Energy"] = 2] = "Energy";
    AmmoType[AmmoType["Missile"] = 3] = "Missile";
    AmmoType[AmmoType["Special"] = 4] = "Special";
})(AmmoType || (AmmoType = {}));
export var WeaponCategory;
(function (WeaponCategory) {
    WeaponCategory[WeaponCategory["Projectile"] = 0] = "Projectile";
    WeaponCategory[WeaponCategory["Energy"] = 1] = "Energy";
    WeaponCategory[WeaponCategory["Missile"] = 2] = "Missile";
    WeaponCategory[WeaponCategory["Special"] = 3] = "Special";
})(WeaponCategory || (WeaponCategory = {}));
//# sourceMappingURL=weapons.js.map